<div class="modal-header">
  <h4 class="modal-title">{{ getTitle() }}</h4>
  <button type="button" class="btn-close close pull-right" (click)="close()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>

<div class="modal-body workflow-content-viewer" style="height: 78vh">
  @if (contentType === 'pdf') {
      <object
        [data]="safeResourceUrl"
        type="application/pdf"
        style="width: 100%; height: 100%;">
      </object>
  } @else if (contentType === 'image') {
      <img
        [src]="imageUrl"
        [alt]="getTitle()"
        style="width: 100%; height: 100%; object-fit: contain;">
  } @else if (contentType === 'iframe') {
      <iframe
        [src]="safeResourceUrl"
        sandbox="allow-same-origin allow-scripts"
        referrerpolicy="no-referrer"
        loading="lazy"
        style="width: 100%; height: 100%;">
      </iframe>
  } @else if (contentType === 'html') {
      <iframe
        [src]="safeResourceUrl"
        sandbox=""
        referrerpolicy="no-referrer"
        loading="lazy"
        style="width: 100%; height: 100%;">
      </iframe>
  } @else if (isLoading) {
    <app-loading-indicator [loading]="true"></app-loading-indicator>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{ 'close' | translate }}
  </button>
</div>
